import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=377d0b20&scoped=true&"
import script from "./menu.js?vue&type=script&lang=js&"
export * from "./menu.js?vue&type=script&lang=js&"
import style0 from "./menu.scss?vue&type=style&index=0&id=377d0b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d0b20",
  null
  
)

export default component.exports